import { useEffect } from "react"
import { extractDate, Format, mmddyyyy } from "@oneethos/shared"
import { ConsumerAppUpdateFn } from "../pages/consumerApplicationForm"

export enum PrequalHelperVariant {
  PrimaryEligibility,
  CoborrowerEligibility,
  CoborrowerInfo
}

export const usePrequalPasteHelper = (
  update: ConsumerAppUpdateFn,
  variant: PrequalHelperVariant
) => {
  const handlePaste = (event: ClipboardEvent) => {
    const text = event.clipboardData.getData("text")
    const parts = text.split("\t")
    if (parts.length === 12 && parts[4].match(/^666\d{6}$/)) {

      const address = {
        streetAddress: [parts[6], parts[7], parts[8]].join(' '),
        city: parts[9],
        state: parts[10],
        zip: parts[11],
        country: 'United States'
      }

      const data = {}
      if (variant === PrequalHelperVariant.CoborrowerEligibility) {
        Object.assign(data, {
          coFirstName: parts[0],
          coMiddleName: parts[1],
          coLastName: parts[2],
          coEmail: parts[3],
          coPhone: process.env.REACT_APP_PREFILL_PHONE || '',
          coSsn: Format.social(parts[4]),
          coBorrowerAddress: address,
          coStatedGrossAnnualIncome: '$101,010',
          coBirthDate: mmddyyyy(extractDate(parts[5])),
        })
      } else {
        // we're pasting a test case
        Object.assign(data, {
          firstName: parts[0],
          middleName: parts[1],
          lastName: parts[2],
          ssn: Format.social(parts[4]),
          phone: process.env.REACT_APP_PREFILL_PHONE || '',
          // email: parts[6],
          birthDate: mmddyyyy(extractDate(parts[5])),
          driversLicenseNo: '101010101',
          driversLicenseIssuingState: 'CA',
          driversLicenseIssueDate: '10/10/2020',
          driversLicenseExpirationDate: '10/10/2040',
          citizenship: 1,
          race: 'White',
          statedGrossAnnualIncome: '$101,010',
          employerName: 'OneEthos',
          occupation: 'Prefilled',
          yearsAtEmployer: 3,
          propertyHeldInTrust: 'no',
          includeCoBorrower: 'no',
          previousEmployment: 'Prefilled',
        
          // hasMortgage: 'no',
          // propertyHeldInTrust: 'no',
  
          ...(variant === PrequalHelperVariant.PrimaryEligibility ? {
            installedAtDifferentLocation: 'yes',
            userAddress: address
          } : { // CoborrowerInfo
            borrowerAddress: address,
          })
        })          
      }

      update(data)
    }
  }

  useEffect(() => {
    document.addEventListener("paste", handlePaste)
    return () => {
      document.removeEventListener("paste", handlePaste)
    }
  }, [])
}
